import * as React from 'react';
import './InvolvementsPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as InvolvementActions from '../../../actions/involvements';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { TrialLookupsLayout } from '../../index';
interface IInvolvementsPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  involvement: Dtos.Involvement[];
  loadingInvolvements: boolean;
  loadInvolvementsSuccess: boolean;
  loadInvolvementsFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface IInvolvementsPageActions {
  clearInvolvements: InvolvementActions.IInvolvementClearActionCreator;
  loadInvolvements: InvolvementActions.IInvolvementLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: InvolvementActions.IInvolvementFilterActionCreator;
}
type InvolvementsPageProps = IInvolvementsPageProps & IInvolvementsPageActions;
class InvolvementsPage extends React.PureComponent<InvolvementsPageProps, any> {
  constructor(props: InvolvementsPageProps) {
    super(props);
    this.clearInvolvements = this.clearInvolvements.bind(this);
  }
  componentDidMount() {
    const {
      loadInvolvements
    } = this.props;
    loadInvolvements();
  }
  componentWillReceiveProps(nextProps: InvolvementsPageProps) {}
  componentDidUpdate(prevProps: InvolvementsPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: InvolvementsPageProps) {}
  componentWillUnmount() {
    this.clearInvolvements();
  }
  clearInvolvements() {
    this.props.clearInvolvements();
  }
  showInvolvements(): boolean {
    const {
      loadingInvolvements,
      loadInvolvementsSuccess
    } = this.props;
    if (!loadingInvolvements && loadInvolvementsSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingInvolvements
    } = this.props;
    return <TrialLookupsLayout loading={loadingInvolvements} permission={Dtos.Permission.InvolvementsView} data-sentry-element="TrialLookupsLayout" data-sentry-component="InvolvementsPage" data-sentry-source-file="InvolvementsPage.tsx">
            {this.renderContent()}
        </TrialLookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Involvements</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InvolvementsCreate) && <Link className={"btn btn-primary"} url={"/settings/trial/involvements/create"}>Create</Link>}
                </div>
            </div>
            {!this.showInvolvements() ? "Loading Involvements" : null}
            {this.showInvolvements() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      involvement
    } = this.props;
    if (!involvement || involvement.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no involvements to view.</span>
            </div>;
    }
    const showPagination = involvement.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={involvement} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : involvement.length} pageSize={showPagination ? undefined : involvement.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no involvement to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/trial/involvements/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: InvolvementsPageProps): IInvolvementsPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.involvements.formFilter,
    involvement: state.involvements.formFilteredData,
    loadingInvolvements: state.involvements.loadState && state.involvements.loadState.status == RequestState.Pending,
    loadInvolvementsSuccess: state.involvements.loadState && state.involvements.loadState.status == RequestState.Success,
    loadInvolvementsFailure: state.involvements.loadState && state.involvements.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): IInvolvementsPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadInvolvements: bindActionCreators(InvolvementActions.LoadInvolvement, dispatch),
    clearInvolvements: bindActionCreators(InvolvementActions.Clear, dispatch),
    filter: bindActionCreators(InvolvementActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(InvolvementsPage);